module.exports = __webpack_public_path__ + "static/img/IMG_20160224_125820.ca7985fb.jpg";